import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-company-home',
  templateUrl: './company-home.component.html',
  styleUrls: ['./company-home.component.css'],
})
export class CompanyHomeComponent {
  constructor(private router: Router) {}

  goToDashboard() {
    this.router.navigate(['/company-admin']);
  }

  stats = [
    { value: '1,200+', label: 'companyHome.statCompanies' },
    { value: '50K+', label: 'companyHome.statInterviews' },
    { value: '30%', label: 'companyHome.statFaster' },
    { value: '90%', label: 'companyHome.statSatisfaction' },
  ];

  reasons = [
    {
      number: '01',
      title: 'companyHome.reason1Title',
      desc: 'companyHome.reason1Desc',
    },
    {
      number: '02',
      title: 'companyHome.reason2Title',
      desc: 'companyHome.reason2Desc',
    },
    {
      number: '03',
      title: 'companyHome.reason3Title',
      desc: 'companyHome.reason3Desc',
    },
    {
      number: '04',
      title: 'companyHome.reason4Title',
      desc: 'companyHome.reason4Desc',
    },
  ];

  builtFeatures = [
    {
      icon: 'bi-clock',
      iconBg: '#E0E7FF',
      iconColor: '#4F46E5',
      title: 'companyHome.feat1Title',
      desc: 'companyHome.feat1Desc',
    },
    {
      icon: 'bi-card-list',
      iconBg: '#E0F2FE',
      iconColor: '#0284C7',
      title: 'companyHome.feat2Title',
      desc: 'companyHome.feat2Desc',
    },
    {
      icon: 'bi-people-fill',
      iconBg: '#D1FAE5',
      iconColor: '#059669',
      title: 'companyHome.feat3Title',
      desc: 'companyHome.feat3Desc',
    },
    {
      icon: 'bi-bar-chart-fill',
      iconBg: '#FEE2E2',
      iconColor: '#DC2626',
      title: 'companyHome.feat4Title',
      desc: 'companyHome.feat4Desc',
    }
  ];

  brands = [
    { name: 'TechNova', img: 'assets/img/Container 1.svg' },
    { name: 'Brainwave', img: 'assets/img/Container (2).svg' },
    { name: 'NEXORA', img: 'assets/img/Container (3).svg' },
    { name: 'innovatix', img: 'assets/img/Container (4).svg' },
  ];

  sidebarItems = [
    { icon: 'bi-building', label: 'Company profile' },
    { icon: 'bi-file-earmark-text', label: 'Job posts/Vacancies', active: true },
    { icon: 'bi-people', label: 'Job applications' },
    { icon: 'bi-camera-video', label: 'Interviews list' },
    { icon: 'bi-bar-chart', label: 'Interview results' },
  ];
}
